'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _ = require('../');

var _PlanScorecardHeader = require('./PlanScorecardHeader.css');

var _PlanScorecardHeader2 = _interopRequireDefault(_PlanScorecardHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanScorecardHeader = (_dec = (0, _reactCssModules2.default)(_PlanScorecardHeader2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PlanScorecardHeader, _Component);

  function PlanScorecardHeader(props) {
    (0, _classCallCheck3.default)(this, PlanScorecardHeader);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PlanScorecardHeader.__proto__ || (0, _getPrototypeOf2.default)(PlanScorecardHeader)).call(this, props));

    var planId = props.planId,
        planData = props.planData;
    var coreissue = planData.coreissue;


    var stmt = null;
    var bckgrnd = null;
    switch (coreissue) {
      case 'deforestation':
        stmt = 'has agribusiness investments that are putting the Amazon rainforest at risk.';
        bckgrnd = 'deforestation';
        break;
      case 'prison-industrial-complex':
        stmt = 'is invested in private prison operators and other companies involved in the prison industrial complex.';
        bckgrnd = 'prisons';
        break;
      default:
        stmt = 'has coal, oil, and gas investments that are putting the global climate at risk.';
        bckgrnd = 'fossil';
        break;
    }

    _this.state = {
      planId: planId,
      planData: planData,
      stmt: stmt,
      bckgrnd: bckgrnd
    };
    return _this;
  }

  (0, _createClass3.default)(PlanScorecardHeader, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          planId = _state.planId,
          planData = _state.planData,
          stmt = _state.stmt,
          bckgrnd = _state.bckgrnd;

      // hack for apple video

      if (planData.short_name === 'Apple') {
        return _react2.default.createElement(
          'div',
          { styleName: 'welcome-banner ' + bckgrnd },
          _react2.default.createElement(
            'div',
            { styleName: 'welcome-banner-gray gray-' + bckgrnd },
            _react2.default.createElement(
              _.ContainerDivs,
              null,
              _react2.default.createElement(
                'div',
                { styleName: 'welcome-banner-wrap' },
                _react2.default.createElement(
                  'h1',
                  { styleName: 'welcome-banner-headline-h1-2' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'welcome-banner-headline-2' },
                    planData.plan_short_name
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'welcome-banner-headline-stmt-2' },
                    stmt
                  )
                ),
                _react2.default.createElement(_.PlanScorecardCompanyVideo, {
                  shortName: planData.short_name
                }),
                _react2.default.createElement(_.PlanScorecardHeaderShare, {
                  planId: planId,
                  planName: planData.plan_short_name,
                  companyTwitterHandle: 'apple',
                  companyTicker: 'AAPL'
                })
              )
            )
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { styleName: 'welcome-banner ' + bckgrnd },
        _react2.default.createElement(
          'div',
          { styleName: 'welcome-banner-gray gray-' + bckgrnd },
          _react2.default.createElement(
            _.ContainerDivs,
            null,
            _react2.default.createElement(
              'div',
              { styleName: 'welcome-banner-wrap' },
              _react2.default.createElement(
                'h1',
                null,
                _react2.default.createElement(
                  'div',
                  { styleName: 'welcome-banner-headline' },
                  planData.plan_short_name
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'welcome-banner-headline-stmt' },
                  stmt
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'welcome-banner-highlight highlight-' + bckgrnd },
          _react2.default.createElement(
            _.ContainerDivs,
            null,
            planData.intro_statement ? _react2.default.createElement(
              'p',
              { styleName: 'welcome-banner-subheading' },
              planData.intro_statement
            ) : null
          )
        )
      );
    }
  }]);
  return PlanScorecardHeader;
}(_react.Component), _class2.propTypes = {
  planId: _react.PropTypes.string.isRequired,
  planData: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = PlanScorecardHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardHeader/PlanScorecardHeader.js
// module id = 1418
// module chunks = 0